module.exports = __webpack_public_path__ + "static/media/submit.ae24d4c4.gif";